'use strict';

const _=require('pulsar-utils/dist-es6/_');let

PersonStatisticsViewModel=class PersonStatisticsViewModel{
constructor(statistics,viewScheduleFunc){
_.ensureInstanceOf('object',statistics);
_.ensureInstanceOf('function',viewScheduleFunc);

this._statistics=statistics;
this._viewSchedule=viewScheduleFunc;
this._groupMembershipsAtScope=[];
}

get id(){
return this._statistics.id;
}

get firstName(){
return this._statistics.firstName;
}

get lastName(){
return this._statistics.lastName;
}

get name(){
return`${this.lastName}, ${this.firstName}`;
}

get employeeId(){
return this._statistics.employeeId;
}

get statistics(){
return this._statistics;
}

get groupMembershipsAtScope(){

return this._groupMembershipsAtScope;
}

get viewSchedule(){
return this._viewSchedule;
}};


module.exports=PersonStatisticsViewModel;
//# sourceMappingURL=personStatisticsViewModel.js.map
